"use strict";
/**
 * Permissions / Ban API Request & Response Types
 *
 * API-facing shapes for the account ban system (see
 * .kiro/specs/account-ban-system).
 *
 * - DerivedPermissionFlags is the ONLY ban data ever returned to the frontend
 *   (via the secure own-profile endpoint). It exposes only which actions are
 *   restricted — never the raw level, scopes detail, reason code, who set it,
 *   or expiration.
 * - BanSlotView / GetBanStateResponse / SetBanStateResponse carry full audit
 *   detail and are returned ONLY by the moderator-gated getBanState/setBanState
 *   endpoints.
 */
Object.defineProperty(exports, "__esModule", { value: true });
